import { PERMISSIONS } from '@/shared/constants/permissions';
import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const AddPermissionToRoleDtoSchema = z.object({
  permissionCode: z.enum(PERMISSIONS),
  roleId: z.number(),
});

const AddPermissionToRoleResponseDtoSchema = z.object();

export type AddPermissionToRoleRequestDto = z.infer<
  typeof AddPermissionToRoleDtoSchema
>;
export type AddPermissionToRoleResponseDto = z.infer<
  typeof AddPermissionToRoleResponseDtoSchema
>;

export const addPermissionToRole = (
  dto: AddPermissionToRoleRequestDto,
  config?: AxiosRequestConfig<AddPermissionToRoleRequestDto>
) => {
  const data = AddPermissionToRoleDtoSchema.parse(dto);
  return api
    .post('/roles/permissions', data, config)
    .then(responseContract(AddPermissionToRoleResponseDtoSchema));
};
